import { useMemo, useState } from "react";

import { SiteConfigSnapshotRow } from "../shared/siteContent";

// Config 스냅샷 행 미리보기 모달 상태를 캡슐화한다.
export function useSiteConfigPreview() {
  const [currentRow, setCurrentRow] = useState<SiteConfigSnapshotRow | null>(null);

  return useMemo(
    () => ({
      currentRow,
      isOpen: !!currentRow,
      openPreview(row: SiteConfigSnapshotRow) {
        setCurrentRow(row);
      },
      closePreview() {
        setCurrentRow(null);
      },
    }),
    [currentRow],
  );
}
